import React from 'react'
import { useDispatch } from 'react-redux'

import { addFlashMessage } from '~/actions'
import { loadCart } from '~/actions/cart'

import { removeSheerIdAssociation } from './sheer-id-removal-modal.actions'
import SheerIdRemovalModal from './sheer-id-removal-modal.component'

export default function SheerIdRemovalModalContainer({
  cartItemInternalId,
  toggleModal,
}) {
  const dispatch = useDispatch()

  const handleSheerIdDiscountRemoval = async () => {
    const removalSuccessful = await removeSheerIdAssociation(cartItemInternalId)
    if (removalSuccessful) {
      dispatch(loadCart())
    } else {
      dispatch(addFlashMessage('error', 'Failed to remove SheerID'))
    }
    toggleModal()
  }

  return (
    <SheerIdRemovalModal
      toggleModal={toggleModal}
      handleSheerIdDiscountRemoval={handleSheerIdDiscountRemoval}
    />
  )
}
